<template>
  <b-sidebar
    ref="floatingDetailPanel"
    :model-value="show"
    :type="type"
    :can-cancel="canCancel"
    :on-cancel="onCancel"
    :fullheight="fullheight"
    :right="right"
    :overlay="overlay"
    :delay="delay"
    @close="onClose"
  >
    <slot />
  </b-sidebar>
</template>

<script>
import { HasRouteChangeListenerMixin } from '@/modules/core/app/mixins/HasRouteChangeListenerMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FloatingDetailPanel',
  emits: ['on-close'],
  mixins: [HasRouteChangeListenerMixin],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    type: {
      type: [String, Object]
    },
    canCancel: {
      type: [Boolean, Array],
      default: () => ['escape', 'outside']
    },
    onCancel: {
      type: Function
    },
    fullheight: {
      type: Boolean,
      default: true
    },
    right: {
      type: Boolean,
      default: true
    },
    overlay: {
      type: Boolean,
      default: false
    },
    delay: {
      type: Number,
      default: 0
    },
    width: {
      type: String,
      default: '400'
    },
    zIndex: {
      type: String,
      default: '$z-index-floating-panel'
    }
  },
  computed: {
    internalWidth() {
      return `${this.width}px`;
    }
  },
  methods: {
    onClose(...args) {
      this.$emit('on-close', ...args);
    },
    onRouteChange() {
      this.$refs.floatingDetailPanel?.close();
    }
  }
};
</script>

<style scoped>
:deep(.sidebar-background) {
  background-color: var(--ce-black) !important;
  opacity: 0.3;
  z-index: v-bind(zIndex);
}

:deep(.sidebar-content) {
  width: v-bind(internalWidth) !important;
  z-index: calc(v-bind(zIndex) + 1);
}
</style>
